import React from 'react';
import styles from './index.module.scss'
import ButtonPrimary from '../ButtonPrimary';

class IrPorVehiculo extends React.Component {

  render() {

    return (
      <div className={styles.cupra}>
        <label className={styles.title}>¡Felicidades!</label>
        <br />
        <label className={styles.subtitle}>Estás a pocos días de experimentar el ADN CUPRA. ¿Estás listo para ser uno de nosotros?</label>

        <div className="row d-flex justify-content-between">
          <div className='col-lg-4 col-md-8 col-6'>
            <label className={styles.subtitle2}>Fecha:</label>
            <br />
            <label className={styles.data}>{(this.props.entrega.fechaEntrega !== undefined && this.props.entrega.fechaEntrega !== null) ? new Date(this.props.entrega.fechaEntrega).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: '2-digit' }) : "--"}</label>
          </div>

          <div className='col-lg-3 col-md-4 col-6'>
            <label className={styles.subtitle2}>Hora:</label>
            <br />
            <label className={styles.data}>{(this.props.entrega.fechaEntrega !== undefined && this.props.entrega.fechaEntrega !== null) ? this.props.entrega.fechaEntrega.split("T")[1].split(":00.")[0] : ""} hrs</label>
          </div>

          <div className='col-lg-5 col-sm-12 col-12 mb-lg-0 mb-md-4 mb-3'>
            <label className={styles.subtitle2}>Concesionaria:</label>
            <br />
            <label className={styles.data}>{this.props.concesionaria?.nombre}</label>
            <br />
            <label className={styles.subtitle2 + " " + styles.extraData}>{(this.props.concesionaria?.direccion !== undefined && this.props.concesionaria?.direccion !== null) ? this.props.concesionaria?.direccion : ""}</label>
          </div>
        </div>

        <label className={styles.subtitle}>Tu asesor es: {this.props.entrega.vendedor}.</label>
        <br />
        <label className={styles.subtitle + " " + styles.extraMargin}>Conoce la mejor ruta a la concesionaria:</label>
        <br />

        <div className={'d-flex justify-content-center ' + styles.marginBtn}>
          <ButtonPrimary textButton={"Ir a la concesionaria"} onClick={() => this.props.functionButton()} styleirvehiculo={true} />
        </div>
      </div>
    )
  }
}

export default IrPorVehiculo
